import SingleSelect from "@/components/form/select/SingleSelect";
import MultipleSelect from "@/components/form/select/MultipleSelect";
import TagsInput from "@/components/form/select/TagsInput";
import CitySelect from "@/components/form/select/CitySelect";
import TreeSingleSelect from "@/components/form/select/TreeSingleSelect";
import DatePicker from "@/components/form/datePicker/DatePicker";
import MonthPicker from "@/components/form/datePicker/MonthPicker";
import YearPicker from "@/components/form/datePicker/YearPicker";
import RangePicker from "@/components/form/datePicker/RangePicker";
import ImgUpload from "@/components/form/upload/ImgUpload";
import FileUpload from "@/components/form/upload/FileUpload";
import FileDragUpload from "@/components/form/upload/FileDragUpload";
import ImgFileUpload from "@/components/form/upload/ImgFileUpload";
import ImgDragUpload from "@/components/form/upload/ImgDragUpload";
import ImgUnlogin from "@/components/form/upload/ImgUploadUnlogin";
import SwitchInput from "@/components/form/switch/SwitchInput";
import SwitchBtn from "@/components/form/switch/SwitchBtn";
import TinymceEditor from "@/components/form/editor/TinymceEditor";
import MarkdownEditor from "@/components/form/editor/MarkdownEditor";
import DictSelect from "@/components/other/DictSelect";
import DictRender from "@/components/other/DictRender";
import PrintOn from "@/components/printOn";

export default {
    PrintOn,
    SingleSelect,
    MultipleSelect,
    TagsInput,
    CitySelect,
    TreeSingleSelect,
    DatePicker,
    MonthPicker,
    YearPicker,
    RangePicker,
    ImgUpload,
    FileUpload,
    ImgFileUpload,
    ImgDragUpload,
    ImgUnlogin,
    FileDragUpload,
    SwitchInput,
    SwitchBtn,
    TinymceEditor,
    MarkdownEditor,
    DictSelect,
    DictRender
}
